import {outter_post} from 'common/js/axios-helper';
import {MemberLevelRateApi} from "./constant/UrlMapper";
const host="8883";


const selectOne = (data) => {
    return outter_post(MemberLevelRateApi.SelectOne, data, host);
};

const add = (data) => {
    return outter_post(MemberLevelRateApi.Add, data, host);
};

const update = (data) => {
    return outter_post(MemberLevelRateApi.Update, data, host);
};

const list = (data) => {
    return outter_post(MemberLevelRateApi.List, data, host);
};

export default {selectOne,add,update, list}



// WEBPACK FOOTER //
// ./src/service/MemberLevelRateService.js